import { createQuery } from 'react-query-kit';

import * as Types from '../api/impact/types.api';
import * as API from '../api/impact/index.api';

//
//

const key = 'impact';

//

export const useQueryImpactGet = createQuery<Types.ImpactResponse, Types.ImpactQuery>({
  queryKey: [key],
  fetcher: (params) => API.getImpactAPI(params),
});

export const useQueryImpactByPurchaseGet = createQuery<
  Types.ImpactResponse,
  Types.ImpactByTransactionQuery
>({
  queryKey: [key, 'by-purchase'],
  fetcher: (params) => API.getImpactTransactionAPI(params),
});

export const useQueryImpactByMerchanteGet = createQuery<
  Types.ImpactResponse,
  Types.ImpactByMerchantQuery
>({
  queryKey: [key, 'by-merchant'],
  fetcher: (params) => API.getImpactMerchantAPI(params),
});
